import { randomArray } from "./array";
import { toTitleCase } from "./string";

export function polyfill() {
  randomArray();
}
